import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { changeStep } from '../../../builder/function/change-step.function';
import { loadRun } from '../../function/load-run.function';
import { setupBindings } from '../../function/setup-bindings.function';
import { teardownBindings } from '../../function/teardown-bindings.function';
import { RunState } from '../../model/run-state.model';
import { currentRunState, defaultRunState } from '../../run.state';

@Component({
    selector: 'cmps-report-run-run',
    templateUrl: './run.component.html',
})
@TakeUntilDestroy()
export class RunComponent implements OnInit {
    /** @private */
    _state: RunState;

    constructor(private readonly _activatedRoute: ActivatedRoute) {
        defaultRunState();
        this._state = currentRunState();
    }

    ngOnInit(): void {
        loadRun(this._activatedRoute.snapshot.paramMap.get('runId'))
            .pipe(takeUntilDestroy(this))
            .subscribe();

        setupBindings()
            .pipe(
                tap((payload) => {
                    if (payload === 'done') {
                        loadRun(
                            this._activatedRoute.snapshot.paramMap.get('runId'),
                        )
                            .pipe(takeUntilDestroy(this))
                            .subscribe();
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe({
                error: () => {
                    console.log(
                        '+++++++++++++++++++++++++++++++++++++++++++++++++++++ NOT OK',
                    );
                    teardownBindings();
                },
                complete: () => {
                    console.log(
                        '+++++++++++++++++++++++++++++++++++++++++++++++++++++ OK',
                    );
                    teardownBindings();
                },
            });
    }

    /** @private */
    _onDownloadCsvClick(): void {
        const csvBase64 = this._state.run.results?.[0]?.artifacts?.find(
            (e) => e.mediaType === 'text/csv',
        )?.data;
        const csvStr = atob(csvBase64);

        const blob = new Blob([csvStr], { type: 'text/plain' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${this._state.run.runId}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
    }

    protected readonly _changeStep = changeStep;
}
